
import store from "../util/store.jsx";
import { CheckpointCardView } from "../views/checkpointCardView.jsx"

function CheckpointCard({ location, onDiscover }) {
  
  const state = store.getState();
  const { stockholm } = state.userData.userProgress;
  const { id } = location;
  const locProgress = stockholm[`loc${id}`];

  const timeCount = Object.keys(locProgress?.time || {}).length;
  const spaceCount = Object.keys(locProgress?.space || {}).length;

  const timeProgress = (timeCount / 4) * 100;
  const spaceProgress = (spaceCount / 4) * 100;
  const totalProgress = timeCount + spaceCount;

  if (!location) return null;

console.log(location);


  return (<CheckpointCardView
            key={ `loc${id}`}
            locId={`loc${id}`}
            data={location}
            isVisited={locProgress}
            timeProgress={timeProgress}
            spaceProgress={spaceProgress}
            totalProgress={totalProgress}
            onDiscover={onDiscover}
          />)


}


export {CheckpointCard}